import { getToken, initializeLDClient } from "../Apimanager/Networking";
import * as actions from "../redux/actions/auth.action";
import * as profileActions from "../redux/actions/profile.action";
import { socketActions, socketSubActions } from "../helper/Websocket";
import { store } from "../redux/store";
import { client } from "../wrapper/apolloWrapper";
import { GET_USER_DATA } from "./userQueries";
import { getAboutYouInfo, getHospitalName, isNewApp } from "../helper/CommonFuncs";
import { checkProvider } from "../viewpages/newpages/teamModule/action/teamAction";
import { setProviderAboutModal } from "../redux/actions/profile.action";
import { signInWithCustomTokenCustom, refreshReduxStoreOnboard as refreshReduxStoreOnboardFirebase } from "./firebase";
import { isCognitoAuth } from "../auth/region";
import { refreshReduxStoreOnboard as refreshReduxStoreOnboardCognito } from "./cognito";
import { isAllowedForRegion } from "./utils";

let abortController = null;

export const fetchQuery = async (query, variables = {}, callback = () => { }, error = () => { }, skip = false) => {
   client
      .query({
         fetchPolicy: "no-cache",
         errorPolicy: "all",
         query: query,
         variables: variables,
         skip,
      })
      .then((data) => {
         callback(data);
      })
      .catch((err) => {
         error(err);
      });
};

export const fetchQueryCancelation = async (
   query,
   variables = {},
   callback = () => { },
   error = () => { },
   skip = false,
   signal = null
) => {
   try {
      if (abortController?.signal?.aborted) {
         abortController = null;
      }
      if (signal && abortController !== null) {
         abortController?.abort();
      }
      abortController = new AbortController();

      // Update the signal in the context
      const context = {
         fetchOptions: {
            signal: abortController?.signal || null,
         },
      };
      client
         .query({
            fetchPolicy: "no-cache",
            errorPolicy: "all",
            query: query,
            variables: variables,
            skip,
            context: context,
         })
         .then((data) => {
            callback(data);
         })
         .catch((err) => {
            error(err);
         });
   } catch (e) {
      console.log(e);
   }
};

export const fetchMutation = async (mutation, variables = {}, callback = () => { }, error = () => { }) => {
   client
      .mutate({
         mutation: mutation,
         variables: variables,
      })
      .then((data) => {
         callback(data);
      })
      .catch((err) => {
         error(err);
      });
};

export const refreshReduxStore = async () => {
   if (isNewApp) {
      refreshReduxStoreOnboard();
   } else {
      refreshReduxStoreOnboardEngage();
   }
};

export const refreshReduxStoreOnboardEngage = async () => {
   const token = await getToken();
   if (token) {
      let str2 = {
         action: socketActions.auth,
         subAction: socketSubActions.exchangeToken,
         firebaseToken: token,
      };
      window.socket.send(str2, (data) => {
         if (data.settings?.status === 1) {
            signInWithCustomTokenCustom(
               data.customToken,
               () => {
                  let userData = { user: data.userData };
                  getProviderData(userData, false, () => { }, true);
                  store.dispatch(actions.saveusercredentials(userData));
               },
               (error) => {
                  console.log(error);
               }
            );
         }
      });
   }
};

export const refreshReduxStoreOnboard = async () => {
   if (isCognitoAuth()) {
      return refreshReduxStoreOnboardCognito(getProviderData);
   }

   return refreshReduxStoreOnboardFirebase(getProviderData);
};

export const getProviderData = (
   loadApi,
   loadProviderData = false,
   callback = (payload) => { },
   refreshUserCredentails = false,
   checkSubscriptionStatus = false
) => {
   let obj = {};
   fetchQuery(GET_USER_DATA, obj, (result) => {
      const data = result.data.getProfile;
      const name = data?.name?.fullName || "";
      const createdAt = data?.createdAt || "";
      const fullName = data?.name;
      const enterpriseName = data?.enterpriseInfo?.name || "";
      const mobileNo = data.contactInformation.mobileNumber;
      const officeNo = data.contactInformation.officeNumber || "";
      const initials = data?.name?.initials || "";
      const title = data?.providerInfo?.title || "";
      const degree = data?.providerInfo?.degree || "";
      const hasCreatedContent = data?.hasCreatedContent;
      const userSettings = data?.settings;
      const dept =
         data.departments?.length > 0
            ? data.departments[0].name
            : data.providerInfo?.department
               ? data.providerInfo?.department
               : "";
      const department = dept !== null && dept !== undefined && dept !== "" ? dept : false;
      const providerInfo = data?.providerInfo?.settings;
      const enterpriseInfo = data?.enterpriseInfo;
      const activityNotViewed = data?.activityNotViewed || 0;
      const id = data?.id || "";
      const departmentObj = data?.departments || [];
      const hospitalObj = data?.hospitals || [];
      const email = data?.contactInformation?.email || "";
      const role = data?.role || "";
      const isTeamsEnabled = data?.enterpriseInfo?.isTeamsEnabled || false;
      const colorCode = data?.colorCode || window.initialColors[0];
      const isProfileCompleted = data?.isProfileCompleted === null ? true : data?.isProfileCompleted;
      const mediaId = data?.media?.mediaId;
      const homeScreen = data?.HomeScreen;
      const countryCode = data.contactInformation.countryCode || null;
      const epicEnabled = data?.epicEnabled || false;
      const extendTrial = data?.extendTrial || false;
      const isSubscribed = data?.isSubscribed || false;
      const isTrialUser = data?.isTrialUser || false;
      const trialRemaining = data?.trialRemaining || 0;
      const referralCode = data?.referralCode || null;
      const referralLink = data?.referralLink || null;
      const noteExpiredPolicyDays = data?.enterpriseInfo?.noteExpiredPolicyDay || null;
      const isNextGenEnable = data?.nextgenEnable || false;
      const isSkipTemplateSelected = data?.isSkipTemplateSelected || false;
      const isTemplateAlertShown = data?.settings?.isTemplateAlertShown || false;
      const enableTemplateLibrary = data?.enterpriseInfo?.enableTemplateLibrary || false;
      const autoSendNotesEHR = data?.autoSendNotesEHR || false;
      const showEhrNoteAutoSendSelection = data?.showEhrNoteAutoSendSelection || false
      const noteRecordingTimeLimit = data?.noteRecordingTimeLimit || null
      var obj = {
         departmentName: dept,
         hospitalName: getHospitalName(data.hospitals),
         name,
         fullName,
         enterpriseName,
         mobileNo,
         officeNo,
         initials,
         title,
         hasCreatedContent,
         degree,
         userSettings,
         hospital: getAboutYouInfo(data.hospitals),
         department: department ? getAboutYouInfo(data.departments) : null,
         providerInfo,
         enterpriseInfo,
         activityNotViewed,
         id,
         createdAt,
         hospitalObj,
         departmentObj,
         email,
         role,
         isTeamsEnabled,
         colorCode,
         mediaId,
         playbackAIOnly: data?.playbackAIOnly,
         homeScreen: homeScreen,
         isFreemiumVerified: data?.isFreemiumVerified || false,
         isfreemiumProvider: data?.isFreemiumProvider || false,
         isSSOLogin: data?.isSSOLogin || false,
         countryCode,
         epicEnabled: epicEnabled,
         extendTrial: extendTrial,
         isSubscribed: isSubscribed,
         isTrialUser: isTrialUser,
         trialRemaining: trialRemaining,
         referralCode: referralCode,
         referralLink: referralLink,
         noteExpiredPolicyDays,
         hl7Enable: data?.hl7Enable || false,
         isNextGenEnable,
         isSkipTemplateSelected,
         isTemplateAlertShown,
         enableTemplateLibrary,
         autoSendNotesEHR,
         showEhrNoteAutoSendSelection,
         noteRecordingTimeLimit
      };
      callback(obj);
      store.dispatch(actions.setProviderDetails(obj));
      if (refreshUserCredentails) {
         let userObject = {
            ...loadApi,
            user: {
               ...loadApi.user,
               name: obj.name,
               hospitalName: obj.hospitalName,
               enterpriseName: obj.enterpriseName,
               mobileNo: obj.mobileNo,
               initials: obj.initials,
               playbackAIOnly: obj.playbackAIOnly,
            },
         };
         store.dispatch(actions.saveusercredentials(userObject));
      }
      if (!loadProviderData) {
         store.dispatch(profileActions.setIsProfileComplete(isProfileCompleted));
         if (isAllowedForRegion) {
            initializeLDClient(obj);
            if (isNewApp) {
               initializePendo(obj);
            }
         }

      }
   });
};

export const setActivityNil = (user) => {
   const updatedUser = {
      ...user,
      activityNotViewed: 0,
   };
   store.dispatch(actions.setProviderDetails(updatedUser));
};

export const initializePendo = (user, unAuthenticated = false) => {
   const accountId = user?.enterpriseName || "";
   const departmentName = user?.departmentName || "";
   const hospitalName = user?.hospitalName || "";
   const departmentId = user?.departmentObj?.length > 0 ? user?.departmentObj[0].id : "";
   const hospitalId = user?.hospitalObj?.length > 0 ? user?.hospitalObj[0].id : "";
   const isSubscribed = user?.isSubscribed || false;
   const isTrialUser = user?.isTrialUser || false;
   const trialRemaining = user?.trialRemaining || 0;
   var obj = {};
   if (process.env.NODE_ENV === "production") {
      obj = {
         visitor: {
            visitorId: user?.id,
            id: user?.id,
            fullName: user?.fullName?.fullName || "",
            isProvider: true,
            email: user?.email,
            department: departmentName,
            hospital: hospitalName,
            departmentId: departmentId,
            hospitalId: hospitalId,
            createdAt: user?.createdAt || "",
            trial_user: isTrialUser,
            is_subscribed: isSubscribed,
            trial_end_date: calculateDate(trialRemaining),
         },

         account: {
            accountId: accountId,
            accountid: accountId,
            id: accountId,
         },
      };
   } else {
      obj = {
         visitor: {
            visitorId: "dev-" + user?.id,
            id: "dev-" + user?.id,
            fullName: user?.fullName?.fullName || "",
            isProvider: true,
            email: user?.email,
            department: departmentName,
            hospital: hospitalName,
            departmentId: departmentId,
            hospitalId: hospitalId,
            createdAt: user?.createdAt,
            trial_user: isTrialUser,
            is_subscribed: isSubscribed,
            trial_end_date: calculateDate(trialRemaining),
         },

         account: {
            accountId: "dev-" + accountId,
            accountid: "dev-" + accountId,
            id: "dev-" + accountId,
         },
      };
   }

   // if (unAuthenticated) {
   //    obj = pendoUnautheticatedUser();
   //    window.pendo.initialize(obj);
   //    return;
   // }
   window.pendo.initialize(obj);
};

export const checkProviderData = (callBack = () => { }) => {
   let reduxStore = store.getState();
   const loggedInProviderDetails = reduxStore.auth.loggedInProviderDetails;
   if (loggedInProviderDetails?.hasCreatedContent) {
      callBack();
   } else if (loggedInProviderDetails !== null) {
      if (checkProvider(loggedInProviderDetails)) {
         callBack();
      } else {
         store.dispatch(setProviderAboutModal(callBack));
      }
   } else {
      store.dispatch(setProviderAboutModal(callBack));
   }
};

export const redirectUserIfTrialHasEnded = (history) => {
   if (localStorage.getItem("trialEndedRedirection") === "true" || window.innerWidth < 768) {
      return;
   }
   let reduxStore = store.getState();
   const loggedInProviderDetails = reduxStore.auth.loggedInProviderDetails;
   if (loggedInProviderDetails?.isTrialUser && loggedInProviderDetails?.trialRemaining <= 0 && isNewApp) {
      localStorage.setItem("trialEndedRedirection", "true");
      history.push("/payment-gateway");
   }
};
export const calculateDate = (daysToAdd) => {
   if (daysToAdd <= 0) return "N/A";
   const today = new Date();
   const futureDate = new Date();
   futureDate.setDate(today.getDate() + daysToAdd);

   // Format to MM/DD/YYYY
   const mm = String(futureDate.getMonth() + 1).padStart(2, "0");
   const dd = String(futureDate.getDate()).padStart(2, "0");
   const yyyy = futureDate.getFullYear();

   const formattedDate = `${mm}/${dd}/${yyyy}`;
   return formattedDate;
};
